import React from "react";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";
import { FIELD_LABEL_SX } from "../onboardingStyles";

const FieldLabel = ({ children, required, sx }) => (
  <Typography variant="body1" sx={{ ...FIELD_LABEL_SX, ...sx }}>
    {children}
    {required && <span className="text-danger">*</span>}
  </Typography>
);

FieldLabel.propTypes = {
  children: PropTypes.node,
  required: PropTypes.bool,
  sx: PropTypes.object,
};

export default FieldLabel;
